import React from 'react'
import JeeLegacydesktop from '../../assets/jee_mock_legacy_web.webp'
import JeeLegacymobile from '../../assets/jee_mock_legacy_mobile.webp'
import styles from './Jeemocktest.module.css'
const JeeLegacySuccess = () => {
  return (
    <div>
         <div className={` container ${styles.jee_legacy_wrapper}`}>
                    <img src={JeeLegacydesktop} alt="jee adv" className={`img-fluid ${styles.d_block}`}/>
                    <img src={JeeLegacymobile} alt="jee adv" className={`img-fluid ${styles.m_block}`} />
            </div>
    </div>
  )
}

export default JeeLegacySuccess